import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@nexdel/core/auth';

// Frontend enforcement is opt-in via VITE_MFA_ENFORCED so this can ship before the org is ready
// to require it. Pair with the backend MFA_ENFORCED flag — turn both on together.
const MFA_ENFORCED =
  (import.meta as { env: Record<string, string> }).env.VITE_MFA_ENFORCED === 'true';

/**
 * When enforcement is on, a password user who hasn't enrolled a second factor is bounced to the
 * Login screen, which renders the mandatory TOTP setup inside the branded auth layout (so the
 * whole flow — sign in, challenge, enrollment — stays on one screen). SSO users never trip this
 * (needsMfaEnrollment is false for them).
 */
export function MfaGate({ children }: { children: ReactNode }) {
  const { needsMfaEnrollment } = useAuth();

  if (MFA_ENFORCED && needsMfaEnrollment) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
